module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/11ecDMr/tc-custom/cover.jpg?1684515367637?1692044807245",
      "alt": "This image is the cover for the book Sacred Isle"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sacred Isle\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("After Tara Hayes's most recent best seller, she and her long-time girlfriend Wendy go on a road trip. They soon arrive along the Florida coastline at the Sacred Isle Diner where yet another case falls into Tara's lap. She uses her training as a PI and the notoriety from her famous book to wedge her way into the investigation of a man who appears to have been killed by a mermaid."), _c('br'), _c('br'), _vm._v("Though Tara knows the idea is ridiculous, the possible siren that haunts the Florida coastline is all she can think about. It's not long before Tara stumbles on Sabrina Taylor, the victim's sister, and forgets about Wendy entirely."), _c('br'), _c('br'), _vm._v("Sabrina is a blonde bombshell with an amazing voice and even more amazing touch. Tara is enchanted right away, but a shocking turn in the investigation makes her realize Sabrina may be more than who she says she is.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Eve Francis\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Eve Francis has appeared in Plunge Magazine, Infernal Ink, Iris New Fiction, MicroHorror, and The Eternal Haunted Summer. Her short stories have been on The Human Echoes Podcast and included in The Grotesquerie, a short horror anthology for Mocha Memoirs Press. She is the former poetry editor for Prosaic Magazine and a peer reviewer for Feral Feminisms. Horror and romance are her favorite genres to write in because everyone knows what it’s like to be afraid -- and fall in love. For more information, please visit evefrancis.wordpress.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0